import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import loadQuotesAPI from '../../api/loadQuotesAPI'

export const loadQuotes = createAsyncThunk(
  'randomquotes/loadQuotes',
  async (payload, { getState, requestId }) => {
    const randomquotes = getState().randomquotes
    if (randomquotes.RequestStatus !== 'pending' ||
      requestId !== randomquotes.RequestId) {
      return
    }
    const response = await loadQuotesAPI()
    return response
  }
)

export const randomQuotesSlice = createSlice({
  name: 'randomquotes',
  initialState: {
    RequestStatus: 'idle',
    RequestId: undefined,
    quotes: [],
  },
  extraReducers: {
    [loadQuotes.pending]: (state, action) => {
      if (state.RequestStatus === 'idle') {
        state.RequestStatus = 'pending'
        state.RequestId = action.meta.requestId
      }
    },
    [loadQuotes.fulfilled]: (state, action) => {
      if (state.RequestStatus === 'pending' &&
        state.RequestId === action.meta.requestId) {
        if (action.payload) {
          state.RequestStatus = 'idle'
          state.RequestId = undefined
          state.quotes = action.payload
          return state
        }
        return state
      }
    },
    [loadQuotes.rejected]: (state, action) => {
      if (state.authRequestStatus === 'pending' &&
        state.authRequestId === action.meta) {
        console.log('Bad API call')
        return state
      }
    },
  },
})

export const getQuotes = state => state.randomquotes.quotes

export default randomQuotesSlice.reducer